/**
 * Legacy audit (2026-08-13): `/ar/live-broadcast` renders only the page title.
 * It exposes no iframe, video/source element, stream URL, channel action, or
 * multiple live sources. Keep the homepage action external until the backend
 * publishes a real supported player contract; do not manufacture `/live`.
 */
export const legacyLiveBroadcastUrl='https://www.guidetosunnah.com/ar/live-broadcast';

